import React, { useState } from 'react';
import { useNavigate } from "react-router-dom"; 

function Login(props) {

    const setLogin = props.setLogin
    const navigate = useNavigate(); 
    function handleSubmit(event) {
      event.preventDefault();
    
      // Validate the username and password.
      if (user !== username || pass !== password) {
        setErrorMessage('Invalid username or password.');
        return;
      }
    
      // Set the power state to true if the user has entered a valid username and password.
      setLogin(true);
      navigate("/admin");
      

    }
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const username = 'HorizonTheHorizon';
  const password = 'WJKM23';

  function userChange(event) {
    setUser(event.target.value);
  }

  function passChange(event) {
    setPass(event.target.value);
  }

  return (
    <div>
        <div className='w-full'>
            <h1 className='text-4xl text-center my-[10px] text-yellow-500 font-extrabold font-[JakartaSansBold]'>Khusus Panitia Lomba</h1>
        </div>
      <form onSubmit={handleSubmit} className='flex flex-col w-72 mx-auto gap-2 mt-[10px]'>
        <input type="text" placeholder="Username" onChange={userChange} className='py-[10px] px-[10px] rounded-md'/>
        <input type="password" placeholder="Password" onChange={passChange} className='py-[10px] px-[10px] rounded-md'/>
        <button type="submit" className='bg-white w-1/2 mx-auto py-[5px] rounded-md'>Login</button>
      </form>
      {errorMessage && <p className="text-red-500 text-center">{errorMessage}</p>}
    </div>
  );
}

export default Login;